<cap-split-button [items]="items()" [attr.data-test]="dataTestId()"></cap-split-button>
